<template>
  <ul v-if="hint?.length" class="integracao-field-hint">
    <li v-for="(line, index) in hint" :key="index">
      <InlineMarkdownText :text="line" />
    </li>
  </ul>
</template>

<script setup lang="ts">
import InlineMarkdownText from "./InlineMarkdownText.vue";

defineProps<{
  hint?: string[];
}>();
</script>

<style lang="scss" scoped>
.integracao-field-hint {
  margin: 4px 0 0;
  padding: 0;
  list-style: none;
  font-size: 12px;
  line-height: 1.4;
  color: var(--p-color-text-secondary, #6b7280);

  li + li {
    margin-top: 2px;
  }
}
</style>
